import * as React from 'react';

import { cn } from '../../utils/cn';

type SpinnerSize = 'sm' | 'md' | 'lg';

interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
  centered?: boolean;
}

const sizeClasses: Record<SpinnerSize, string> = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8'
};

export const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  ({ size = 'md', className, centered = false, ...props }, ref) => {
    const spinnerElement = (
      <div
        ref={ref}
        className={cn('animate-spin rounded-full h-4 w-4 border-b-2 border-gray-600', sizeClasses[size], className)}
        {...props}
      />
    );

    if (centered) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100vw'
          }}
        >
          {spinnerElement}
        </div>
      );
    }

    return spinnerElement;
  }
);

Spinner.displayName = 'Spinner';
